/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidCancelPathParams,
  PostApiV1IndividualpaymentParcelsParcelidCancel401,
  PostApiV1IndividualpaymentParcelsParcelidCancel404,
  PostApiV1IndividualpaymentParcelsParcelidCancel500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidCancel.ts";

function getPostApiV1IndividualpaymentParcelsParcelidCancelUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelPathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/cancel` as const,
  };
  return res;
}

/**
 * @description Migrado do legado IndividualPayment/CancelParcel. **(Requer Authorization para autenticação)**
 * @summary Cancela uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/cancel}
 */
export async function postApiV1IndividualpaymentParcelsParcelidCancel(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelPathParams["parcelId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidCancelMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidCancel401
      | PostApiV1IndividualpaymentParcelsParcelidCancel404
      | PostApiV1IndividualpaymentParcelsParcelidCancel500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidCancelUrl(
      parcelId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
